import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Row, Col } from 'react-bootstrap';
import SimpleCMSImg from '../../images/simple-cms.svg';
import HomePageStyle from './home-page.module.scss';
import ScrollAnimation from 'react-animate-on-scroll';

const SimpleCMS = () => (
  <StaticQuery
    query={graphql`
      query SimpleCMS {
        contentfulFsdHompage {
          homepageReference {
            sectionContent5 {
              subtitle {
                subtitle
              }
              sectionParagraph {
                json
              }
            }
          }
        }
      }
    `}
    render={(data) => (
      <div className={HomePageStyle.sectionDiv}>
        <Row className={HomePageStyle.section2}>
          <Col sm={6} className={HomePageStyle.section2Col1}>
            {/* Section5 Subtitle */}
            <h3 className={HomePageStyle.sectionTitleLeftAlign}>
              {
                data.contentfulFsdHompage.homepageReference.sectionContent5
                  .subtitle.subtitle
              }
            </h3>
            {/* Section5 Descriptive Paragraph */}
            <div className={HomePageStyle.sectionDescriptionLeftAlign}>
              {documentToReactComponents(
                data.contentfulFsdHompage.homepageReference.sectionContent5
                  .sectionParagraph.json
              )}
            </div>
          </Col>
          <Col sm={6}>
            <ScrollAnimation
              animateIn='fadeInUp'
              duration={2}
              animateOnce={true}
            >
              <SimpleCMSImg className={HomePageStyle.simpleCmsImg} />
            </ScrollAnimation>
          </Col>
        </Row>
      </div>
    )}
  />
);

export default SimpleCMS;
